/* Copyright 2013 - 2024 Waiterio LLC */
import { css } from '@emotion/react'

export default css`
  label: d-lg-none;
  @media (min-width: 992px) {
    display: none !important;
  }
`
